(function () {

  var input        = document.getElementById('pp-search-input');
  var clearBtn     = document.querySelector('.pp-clear-btn');
  var tagBtns      = document.querySelectorAll('.pp-tag');
  var resultInfo   = document.querySelector('.pp-search-result-info');
  var noResults    = document.getElementById('pp-no-results');
  var blogGrid     = document.querySelector('.blog-articles');
  var pagination   = document.querySelector('.pagination-wrapper, .pagination, nav[role="navigation"]');

  if (!input || !blogGrid) { return; }

  // Alle Artikel-Karten original speichern
  var originalHTML  = blogGrid.innerHTML;
  var allArticles   = [];
  var articlesLoaded = false;

  // --------------------------------------------------
  // ALLE Blog-Artikel laden (alle Seiten, via fetch)
  // --------------------------------------------------
  function loadAllArticles(callback) {
    if (articlesLoaded) { callback(); return; }

    var page = 1;
    var maxPages = 20;

    function fetchPage(p) {
      fetch('/blogs/paneelpalast-magazin?page=' + p)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var cards = doc.querySelectorAll('.blog-articles__article');

          if (cards.length === 0 || p > maxPages) {
            articlesLoaded = true;
            callback();
            return;
          }

          cards.forEach(function (card) {
            var titleEl = card.querySelector('h2 a, h3 a, .article-card__title a, .card__heading a');
            var excerptEl = card.querySelector('.article-card__excerpt, .article-card__info, p');
            var imageEl = card.querySelector('img');

            allArticles.push({
              title:   titleEl ? titleEl.textContent.trim() : '',
              url:     titleEl ? titleEl.getAttribute('href') : '#',
              excerpt: excerptEl ? excerptEl.textContent.trim() : '',
              text:    card.textContent.toLowerCase(),
              html:    card.outerHTML
            });
          });

          fetchPage(p + 1);
        })
        .catch(function () {
          articlesLoaded = true;
          callback();
        });
    }

    fetchPage(1);
  }

  // --------------------------------------------------
  // Ergebnisse rendern
  // --------------------------------------------------
  function renderResults(query) {
    var q = query.toLowerCase().trim();

    if (q === '') {
      // Suche leer → Original wiederherstellen
      blogGrid.innerHTML = originalHTML;
      if (noResults) { noResults.style.display = 'none'; }
      if (resultInfo) { resultInfo.style.display = 'none'; }
      if (pagination) { pagination.style.display = ''; }
      return;
    }

    // Pagination verstecken bei aktiver Suche
    if (pagination) { pagination.style.display = 'none'; }

    var matches = allArticles.filter(function (a) {
      return a.text.indexOf(q) !== -1;
    });

    if (matches.length > 0) {
      blogGrid.innerHTML = matches.map(function (a) {
        return a.html;
      }).join('');
      if (noResults) { noResults.style.display = 'none'; }
    } else {
      blogGrid.innerHTML = '';
      if (noResults) { noResults.style.display = 'block'; }
    }

    if (resultInfo) {
      resultInfo.style.display = 'block';
      resultInfo.textContent = matches.length > 0
        ? matches.length + ' Artikel gefunden für: "' + query + '"'
        : '';
    }
  }

  // --------------------------------------------------
  // Suche ausführen
  // --------------------------------------------------
  function doSearch(query) {
    loadAllArticles(function () {
      renderResults(query);
    });

    // Aktive Tags
    var q = query.toLowerCase().trim();
    tagBtns.forEach(function (tag) {
      var tagVal = (tag.getAttribute('data-tag') || '').toLowerCase().trim();
      tag.classList.toggle('pp-tag--active', q !== '' && tagVal === q);
    });

    // Clear-Button
    if (clearBtn) {
      clearBtn.classList.toggle('is-visible', q !== '');
    }
  }

  // --------------------------------------------------
  // Events
  // --------------------------------------------------
  var debounceTimer;
  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      doSearch(input.value);
    }, 300);
  });

  var searchBtn = document.querySelector('.pp-search-btn');
  if (searchBtn) {
    searchBtn.addEventListener('click', function () {
      doSearch(input.value);
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      doSearch('');
      input.focus();
    });
  }

  tagBtns.forEach(function (tag) {
    tag.addEventListener('click', function () {
      var tagValue = tag.getAttribute('data-tag') || '';
      if (tag.classList.contains('pp-tag--active')) {
        input.value = '';
        doSearch('');
      } else {
        input.value = tagValue;
        doSearch(tagValue);
      }
    });
  });

}());
